import React, { FC } from 'react';
import { Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import DialogContent from '@mui/material/DialogContent';

import AddressFields from '../../ServicesSection/detailsTabHelpers/AddressFields';
import { DropDownOption } from '../../../../../../types';
import ModalFormTitle from '../../../../../../components/Tables/TableWithModalEdit/modalFormPieces/ModalFormTitle';
import { DraggableDialog } from '../../../../../../components/DraggablePaper/DraggablePaper';
import { DialogActionsWrapper } from '../../../../../../components/Tables/TableWithModalEdit/modalFormPieces/ModalFormActions/ModalFormActions';
import { ToggleDialog } from '../../../../../../components/Tables/TableWithModalEdit/modalFormPieces/IFormModal';

type AddressProps = {
    countryOptions: DropDownOption[];
    startFieldName: string;
    addressOpen: boolean;
    toggleAddressOpen: ToggleDialog;
};

export const AddressDialog: FC<AddressProps> = ({
    countryOptions,
    startFieldName,
    addressOpen,
    toggleAddressOpen
}: AddressProps) => {
    return (
        <DraggableDialog open={addressOpen} onClose={toggleAddressOpen} maxWidth="sm" fullWidth>
            <ModalFormTitle title="Address Entry" toggleDialog={toggleAddressOpen} />
            <DialogContent>
                <AddressFields
                    startFieldName={startFieldName}
                    countryOptions={countryOptions}
                    isCountryFullOption
                />
            </DialogContent>
            <DialogActionsWrapper>
                <Button onClick={() => toggleAddressOpen(false)} variant="outlined">
                    Cancel
                </Button>
                <Button onClick={() => toggleAddressOpen(false)} variant="contained" color="primary">
                    OK
                </Button>
            </DialogActionsWrapper>
        </DraggableDialog>
    );
};
